import { practiceResult } from '@ezchops/model/lib/lesson';
import React, { useMemo } from 'react';
import { useLessonPageContext } from './LessonPageContext';
export const EvaluationContext = React.createContext(undefined);
export function EvaluationContextProvider(props) {
    const { children, stepIndex, evaluator } = props;
    const { lesson, progress } = useLessonPageContext();
    const context = useMemo(() => {
        const summary = evaluator?.summary(evaluator?.evaluation) ?? null;
        const grade = summary != null && summary.maxScore != 0 ? summary.score / summary.maxScore : null;
        const isKeyStep = lesson.steps.length - 1 === stepIndex;
        const pr = grade == null ? null : practiceResult(grade);
        const result = pr == null ? null : {
            ...pr,
            rating: isKeyStep ? pr.grade : 0
        };
        const exercise = lesson.steps[stepIndex];
        const exerciseProgress = progress.steps[stepIndex];
        const { passed: isStepPassed } = exerciseProgress;
        return {
            exercise, stepIndex, evaluator, summary, result,
            isKeyStep, isStepPassed, rating: isKeyStep ? result?.grade : 0
        };
    }, [evaluator, stepIndex, lesson.steps, progress.steps]);
    return React.createElement(EvaluationContext.Provider, { value: context }, children);
}
export function useEvaluationContext() {
    const context = React.useContext(EvaluationContext);
    if (context == null) {
        throw new Error('useEvaluationContext must be used within EvaluationContextProvider');
    }
    return context;
}
//# sourceMappingURL=EvaluationContext.js.map